"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const AdaptableContext_1 = require("../../View/AdaptableContext");
const useAgGridClassName = (deps = []) => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    return (0, react_1.useMemo)(() => {
        if (adaptable) {
            return adaptable.getAgGridCurrentThemeName();
        }
        return '';
    }, deps);
};
exports.default = useAgGridClassName;
